import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';

// components
import { Button, FormGroup, Input, Row, Col, Spinner, Label, Collapse, Form } from "reactstrap";
import Select from 'react-select'
import EbtidaChart from "./Graficos/EbitdaChart";
import ReceitaOperacionalChart from "./Graficos/ReceitaOperacionalChart";
import DespesaChart from "./Graficos/DespesaChart";
import DespesaPessoalChart from "./Graficos/DespesaPessoalChart";
import DespesaOcupacaoChart from "./Graficos/DespesaOcupacaoChart";
import DespesaCartaoChart from "./Graficos/DespesaCartaoChart";
import DespesaEstruturalChart from "./Graficos/DespesaEstruturalChart";
import TableDadosDRE from "./Graficos/TableDadosDRE";

//utils
import { showMessage } from "utils/message.js";
import { getSessionCookie } from 'utils/cookies';
import { formateMesAno, formateCurrencyInput, formateCurrencyApi, formateDateByMesAno, formateCurrencyValueApi } from "utils/formats";
import { monthDiff } from "utils/generics";

// api
import usuario_api from "api/usuario_api.js";
import dadosimplantacaotim_api from 'api/dadosimplantacaotim_api';
import dashboardbi_api from "api/dashboardbi_api";

export default function Dashboard13MBI({ }) {
    const { register, handleSubmit, setValue, clearErrors, errors } = useForm({ mode: "onBlur" });

    var session = getSessionCookie();

    const [showLoading, setshowLoading] = useState(false);

    useEffect(() => {
        //se tiver a permissão habilitade carrega as regionais
        usuario_api.getFuncionalidadeAcaoLiberada("Dashboard", "Visualizar").then((result) => { loadOptionsRegionais(); });

    }, []);

    // Regional
    const [options_regionais, set_options_regionais] = useState([]);
    const loadOptionsRegionais = () => {
        dadosimplantacaotim_api.getRegionais().then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _regionais = [];
                result.data.map((m) => _regionais.push({ label: m, value: m }));
                set_options_regionais(_regionais);
                if (_regionais.length == 1) {
                    set_regionais(_regionais);
                    setValue("regional", _regionais, true);
                    loadOptionsSegmentos(_regionais);
                }
            }
        })
    }
    const [regionais, set_regionais] = useState([]);
    const handleChangeRegional = (value) => {
        ClearFiltros("regional");

        loadOptionsSegmentos(value);

        let _regionais = [];
        if (value) {
            value.map(m => {
                _regionais.push({
                    label: m.label,
                    value: m.value
                });
            });
        }

        set_regionais(_regionais);

        if (_regionais.length > 0)
            setValue("regional", _regionais, true);
    }

    //Segmento
    const [options_segmentos, set_options_segmentos] = useState([]);
    const loadOptionsSegmentos = (_regionais) => {

        let _regionaisArray = [];
        if (_regionais !== null)
            _regionais.map((m) => _regionaisArray.push(m.value));
        else
            _regionais = null;

        dashboardbi_api.getSegmentosbyRegionais(_regionaisArray).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _segmentos = [];
                result.data.map((m) => _segmentos.push({ label: m, value: m }));
                set_options_segmentos(_segmentos);
            }
        })
    }
    const [segmentos, set_segmentos] = useState([]);
    const handleChangeSegmento = (value) => {
        ClearFiltros("segmento");

        loadOptionsMesAno(value);

        let _segmentos = []
        if (value) {
            value.map(m => {
                _segmentos.push({
                    label: m.label,
                    value: m.value
                })
            });
        }

        set_segmentos(_segmentos);

        if (_segmentos.length > 0)
            setValue("segmento", _segmentos, true);

    }

    // Meses
    const [last13Months, set_last13Months] = useState([]);

    const loadOptionsMesAno = (_segmentos) => {
        let today = new Date();
        let threeMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 3, 1); //Data de 3 meses atrás com base no mês e ano atual
        let last13MonthsArray = [];

        for (let i = 12; i >= 0; i--) {
            let month = threeMonthsAgo.getMonth() - i;
            let year = threeMonthsAgo.getFullYear() + Math.floor(month / 12); //Obtém o ano, levando em conta a transição de ano
            let adjustedMonth = (month % 12 + 12) % 12; //Ajusta o valor do mês para lidar com valores negativos e maiores que 11

            let date = new Date(year, adjustedMonth, 1);
            let label = formateMesAno(date);
            let value = formateMesAno(date);

            last13MonthsArray.push({ label, value });
        }

        set_last13Months(last13MonthsArray);

        if (_segmentos) {
            loadOptionsGruposEconomicos(last13MonthsArray, _segmentos);
        }
    }

    // Grupos Econômicos
    const [options_gruposeconomicos, set_options_gruposeconomicos] = useState([]);
    const loadOptionsGruposEconomicos = (_mesAno, _segmentos) => {
        let _mesAnoArray = [];
        if (_mesAno !== null)
            _mesAno.map((m) => _mesAnoArray.push(m.value));
        else
            _mesAno = null;

        let _segmentosArray = [];
        if (_segmentos !== null)
            _segmentos.map((m) => _segmentosArray.push(m.value));

        let _regionaisArray = [];
        if (regionais !== null)
            regionais.map((m) => _regionaisArray.push(m.value));

        let json_filtros = {
            regionais: _regionaisArray,
            segmentos: _segmentosArray,
            mesAnoSelecionados: _mesAnoArray
        }

        dashboardbi_api.getGruposEconomicosbyRegionaisSegmentos(json_filtros).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _gruposeconomicos = [];
                result.data.map((m) => _gruposeconomicos.push({ label: m, value: m }));
                set_options_gruposeconomicos(_gruposeconomicos);
            }
        })
    }
    const [gruposeconomicos, set_gruposeconomicos] = useState([]);
    const handleChangeGrupoEconomico = (value) => {
        ClearFiltros("grupo");

        loadOptionsLojas(value);

        let _gruposEconomicos = []
        if (value) {
            value.map(m => {
                _gruposEconomicos.push({
                    label: m.label,
                    value: m.value
                });
            });
        }
        set_gruposeconomicos(_gruposEconomicos);

        if (_gruposEconomicos.length > 0)
            setValue("grupoeconomico", _gruposEconomicos, true);
    }

    const handleClickSelecionarTodosGrupos = () => {
        set_lojas([]);
        loadOptionsLojas(options_gruposeconomicos);

        let _gruposEconomicos = []
        if (options_gruposeconomicos.length > 0) {
            options_gruposeconomicos.map(m => {
                _gruposEconomicos.push({
                    label: m.label,
                    value: m.value
                });
            });
        }

        set_gruposeconomicos(_gruposEconomicos);

        if (_gruposEconomicos.length > 0)
            setValue("grupoeconomico", _gruposEconomicos, true);
    }

    // Lojas
    const [options_lojas, set_options_lojas] = useState([]);
    const loadOptionsLojas = (_gruposeconomicos) => {

        let _gruposeconomicosArray = [];
        if (_gruposeconomicos !== null)
            _gruposeconomicos.map((m) => _gruposeconomicosArray.push(m.value));
        else
            _gruposeconomicos = null;

        let _regionaisArray = [];
        if (regionais !== null)
            regionais.map((m) => _regionaisArray.push(m.value));

        let _mesAnoArray = [];
        if (last13Months !== null)
            last13Months.map((m) => _mesAnoArray.push(m.value));

        let json_filtros = {
            regionais: _regionaisArray,
            gruposeconomicos: _gruposeconomicosArray,
            mesAnoSelecionados: _mesAnoArray
        }

        dashboardbi_api.getLojasbyGruposERegionais(json_filtros).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _lojas = [];
                result.data.map((m) => _lojas.push({ label: m.identificacao, value: m.custCode }));

                includeMatrizToLojas(_lojas, _gruposeconomicos);

            }
        })
    }

    const includeMatrizToLojas = (lojas, grupos) => {
        //Incluir o escritório matriz de cada grupo economico na lista de lojas
        let _matrizElojas = []
        _matrizElojas = lojas;
        if (grupos !== null) {
            grupos.map(m => {
                _matrizElojas.push({
                    label: "ESCRITÓRIO MATRIZ - " + m.label,
                    value: m.value
                });
            });
        }
        set_options_lojas(_matrizElojas);
    }

    const [lojas, set_lojas] = useState([]);
    const handleChangeLojas = (value) => {
        let _lojas = [];
        let exibeRateioMatriz = false;
        let exibeRateioOutraLoja = false;

        if (value) {
            value.map((m) => {
                if (m.label.indexOf("ESCRITÓRIO MATRIZ - ") !== -1) {// verifica se existe ESCRITÓRIO MATRIZ - selecionado entre as lojas (retornar um valor diferente de -1, significa que a string "ESCRITÓRIO MATRIZ - " foi encontrada na propriedade label do objeto m)
                    exibeRateioMatriz = true;
                } else {
                    exibeRateioOutraLoja = true;
                }

                _lojas.push({
                    label: m.label,
                    value: m.value,
                });
            });
        }

        set_lojas(_lojas);

        if (_lojas.length > 0) {
            setValue("lojas", _lojas, true);
            clearErrors("lojas");
        }
        else {
            setValue("lojas", [], false);
        }
        //SOMENTE IRÁ EXIBIR O CAMPO RATEIO ADM SE EU TENHO PELOMENOS 1 loja do tipo ESCRITORIO MATRIZ SELECIONADO ENTRE AS LOJAS E PELOMENOS 1 LOJA QUE NÃO SEJA do tipo ESCRITÓRIO MATRIZ SELECIONADA
        if (exibeRateioMatriz && exibeRateioOutraLoja) {
            set_visibleRateio(true);
        } else {
            set_visibleRateio(false);
        }
    }

    const handleClickSelecionarTodasLojas = () => {
        let _lojas = [];

        if (options_lojas.length > 0) {
            options_lojas.map(m => {
                _lojas.push({
                    label: m.label,
                    value: m.value
                });
            });
        }

        set_lojas(_lojas);

        if (_lojas.length > 0) {
            setValue("lojas", _lojas, true);
            clearErrors("lojas");
        }
        else {
            setValue("lojas", [], false);
        }

        set_visibleRateio(true)
    }

    // Rateio ADM
    const [visibleRateio, set_visibleRateio] = useState(false);
    const options_rateioADM = [
        { label: "SIM", value: "SIM" },
        { label: "NÃO", value: "NAO" }
    ];
    const [rateioADM, set_rateioADM] = useState("NAO");
    const handleChangeRateioADM = (value) => {
        set_rateioADM(value);
        clearErrors("rateioAdm");
        setValue("rateioAdm", value, true);
    }

    //Filtrar
    const [ebitdaData, set_ebitdaData] = useState(null);
    const [receitaOperacionalData, set_receitaOperacionalData] = useState(null);
    const [despesaData, set_despesaData] = useState(null);
    const [despesaPessoalData, set_despesaPessoalData] = useState(null);
    const [despesaOcupacaoData, set_despesaOcupacaoData] = useState(null);
    const [despesaCartaoData, set_despesaCartaoData] = useState(null);
    const [despesaEstruturalData, set_despesaEstruturalData] = useState(null);
    const [tableDREData, set_tableDREData] = useState(null);
    const [visibleGraficoEbitda, set_visibleGraficoEbitda] = useState(false);
    const [visibleReceitaOperacionalChart, set_visibleReceitaOperacionalChart] = useState(false);
    const [visibleDespesaChart, set_visibleDespesaChart] = useState(false);
    const [visibleDespesaPessoalChart, set_visibleDespesaPessoalChart] = useState(false);
    const [visibleDespesaOcupacaoChart, set_visibleDespesaOcupacaoChart] = useState(false);
    const [visibleDespesaCartaoChart, set_visibleDespesaCartaoChart] = useState(false);
    const [visibleDespesaEstruturalChart, set_visibleDespesaEstruturalChart] = useState(false);
    const [visibleTableDRE, set_visibleTableDRE] = useState(false);

    const handleClickFiltrar = () => {

        if (visibleRateio) {
            if (rateioADM == null) {
                showMessage("Aviso", "É necessário selecionar o rateio ADM!", 'error', null);
                return;
            }
        }

        if (lojas.length == 0) {
            showMessage("Aviso", "É necessário selecionar a loja!", 'error', null);
            return;
        }

        let lojasArray = [];
        lojas.map((m) => lojasArray.push(m.value));
        let mesAnoArray = [];
        last13Months.map((m) => mesAnoArray.push(m.value));

        let json_filter = {
            lojasSelecionadas: lojasArray,
            rateioADM: rateioADM,
            mesAnoSelecionados: mesAnoArray,
        }
        setshowLoading(true);
        dashboardbi_api.getDadosDashboard13M(json_filter).then(result => {
            if (result.status !== 200) {
                setshowLoading(false);
                showMessage("Aviso", result.message, 'error', null);
                set_visibleGraficoEbitda(false);
                set_visibleReceitaOperacionalChart(false);
                set_visibleDespesaChart(false);
                set_visibleDespesaPessoalChart(false);
                set_visibleDespesaOcupacaoChart(false);
                set_visibleDespesaCartaoChart(false);
                set_visibleDespesaEstruturalChart(false);
                set_visibleTableDRE(false);
            }
            else {
                setshowLoading(false);
                if (result.data.ebitda != null) {
                    set_ebitdaData(result.data.ebitda);
                    set_visibleGraficoEbitda(true);
                }
                else {
                    showMessage("Aviso", "Não foram encontrados dados com os filtros informados!", 'error', null);
                    set_visibleGraficoEbitda(false);
                }
                if (result.data.receitaOperacional != null) {
                    set_receitaOperacionalData(result.data.receitaOperacional);
                    set_visibleReceitaOperacionalChart(true)
                }
                else {
                    showMessage("Aviso", "Não foram encontrados dados com os filtros informados!", 'error', null);
                    set_visibleReceitaOperacionalChart(false);
                }
                if (result.data.despesa != null) {
                    set_despesaData(result.data.despesa);
                    set_visibleDespesaChart(true)
                }
                else {
                    showMessage("Aviso", "Não foram encontrados dados com os filtros informados!", 'error', null);
                    set_visibleDespesaChart(false);
                }
                if (result.data.despesaPessoal != null) {
                    set_despesaPessoalData(result.data.despesaPessoal);
                    set_visibleDespesaPessoalChart(true)
                }
                else {
                    showMessage("Aviso", "Não foram encontrados dados com os filtros informados!", 'error', null);
                    set_visibleDespesaPessoalChart(false);
                }
                if (result.data.despesaOcupacao != null) {
                    set_despesaOcupacaoData(result.data.despesaOcupacao);
                    set_visibleDespesaOcupacaoChart(true)
                }
                else {
                    showMessage("Aviso", "Não foram encontrados dados com os filtros informados!", 'error', null);
                    set_visibleDespesaOcupacaoChart(false);
                }
                if (result.data.despesaCartao != null) {
                    set_despesaCartaoData(result.data.despesaCartao);
                    set_visibleDespesaCartaoChart(true)
                }
                else {
                    showMessage("Aviso", "Não foram encontrados dados com os filtros informados!", 'error', null);
                    set_visibleDespesaCartaoChart(false);
                }
                if (result.data.despesaEstrutural != null) {
                    set_despesaEstruturalData(result.data.despesaEstrutural);
                    set_visibleDespesaEstruturalChart(true)
                }
                else {
                    showMessage("Aviso", "Não foram encontrados dados com os filtros informados!", 'error', null);
                    set_visibleDespesaEstruturalChart(false);
                }
                if (result.data.tabelaDRE != null) {
                    set_tableDREData(result.data.tabelaDRE);
                    set_visibleTableDRE(true)
                }
                else {
                    showMessage("Aviso", "Não foram encontrados dados com os filtros informados!", 'error', null);
                    set_visibleTableDRE(false);
                }
                if (result.data.ebitda != null &&
                    result.data.receitaOperacional != null &&
                    result.data.despesa != null &&
                    result.data.despesaPessoal != null &&
                    result.data.despesaOcupacao != null &&
                    result.data.despesaCartao != null &&
                    result.data.despesaEstrutural != null &&
                    result.data.tabelaDRE != null) {
                    set_visibleFiltros(false);
                    set_btnRollbackFiltro('Exibir Filtros')
                }
                else {
                    set_visibleFiltros(true);
                }
            }
        })
    }

    //limpa os filtros, pois seus dados são dinamicos (dependem do anterior)
    const ClearFiltros = (filtro) => {
        if (filtro == "regional") {
            set_segmentos([]);
            set_options_segmentos([]);
            set_gruposeconomicos([]);
            set_options_gruposeconomicos([]);
            set_lojas([]);
            set_options_lojas([]);
            set_visibleRateio(false);
        }
        else if (filtro == "segmento") {
            set_gruposeconomicos([]);
            set_options_gruposeconomicos([]);
            set_lojas([]);
            set_options_lojas([]);
            set_visibleRateio(false);
        }
        else if (filtro == "grupo") {
            set_lojas([]);
            set_options_lojas([]);
            set_visibleRateio(false);
        }
    }

    //voltar a exibir os filtros
    const [btnRollbackFiltro, set_btnRollbackFiltro] = useState('Exibir Filtros');
    const [visibleFiltros, set_visibleFiltros] = useState(true);
    const handleClickFiltros = () => {

        if (btnRollbackFiltro == "Ocultar Filtros") {
            set_visibleFiltros(false);
            set_btnRollbackFiltro('Exibir Filtros')

        }
        else {
            set_visibleFiltros(true);
            set_btnRollbackFiltro('Ocultar Filtros')
        }

    }
    // estilos
    const customStyles = {
        valueContainer: (provided, state) => ({
            ...provided,
            height: '60px',
            padding: '0 6px',
            overflow: 'auto'
        })
    };

    const ColoredLine = ({ color }) => (
        <hr
            style={{
                color: color,
                backgroundColor: "#343a40",
                height: 35,
                display: 'flex',
                alignItems: "center",
                flex: 1,
                opacity: 0.2

            }}
        />
    );

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }

            <div className="content">
                {ebitdaData != null &&
                    <Row>
                        <Col lg="12" md="12" sm="12" className="text-right">
                            <Button color="warning" type="button" onClick={handleClickFiltros}><i className="fas fa-filter"></i> {btnRollbackFiltro}</Button>
                        </Col>
                    </Row>
                }
                {visibleFiltros &&
                    <>
                        <Row className="mb-4 align-items-end">
                            <Col lg="6" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Regional *</label>
                                    <Select
                                        name="regional"
                                        options={options_regionais}
                                        getOptionLabel={o => o.label}
                                        getOptionValue={o => o.value}
                                        value={options_regionais.filter(({ value }) => regionais.filter(f => f.value == value).length > 0)}
                                        onChange={(o) => handleChangeRegional(o)}
                                        classNamePrefix="select"
                                        placeholder="[ Selecione ]"
                                        isMulti={true}
                                        ref={e => register({ name: "regional" })
                                        }
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg="6" md="12" sm="12">
                                <FormGroup>
                                    <label className="form-control-label">Segmento *</label>
                                    <Select
                                        name="segmento"
                                        options={options_segmentos}
                                        getOptionLabel={o => o.label}
                                        getOptionValue={o => o.value}
                                        value={options_segmentos.filter(({ value }) => segmentos.filter(f => f.value == value).length > 0)}
                                        onChange={(o) => handleChangeSegmento(o)}
                                        classNamePrefix="select"
                                        placeholder="[ Selecione ]"
                                        isMulti={true}
                                        ref={e => register({ name: "segmento" })
                                        }
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="4" md="12" sm="12">
                                <FormGroup>
                                    <Row>
                                        <Col lg="6" md="12" sm="12">
                                            <label className="form-control-label">Grupo Econômico *</label>
                                        </Col>
                                        <Col lg="6" md="12" sm="12">
                                            <div style={{ textAlign: 'right', marginTop: '3px' }}>
                                                <a href="#" onClick={() => handleClickSelecionarTodosGrupos()} style={{ marginTop: '10px' }}>
                                                    {'Selecionar Todos'}
                                                </a>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Select
                                        name="grupoeconomico"
                                        styles={customStyles}
                                        options={options_gruposeconomicos}
                                        getOptionLabel={o => o.label}
                                        getOptionValue={o => o.value}
                                        value={options_gruposeconomicos.filter(({ value }) => gruposeconomicos.filter(f => f.value == value).length > 0)}
                                        onChange={(o) => handleChangeGrupoEconomico(o)}
                                        classNamePrefix="select"
                                        placeholder="[ Selecione ]"
                                        isMulti={true}
                                        ref={e => register({ name: "grupoeconomico" })
                                        }
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg="6" md="12" sm="12">
                                <FormGroup>
                                    <Row>
                                        <Col lg="6" md="6" sm="12">
                                            <label className="form-control-label">Lojas *</label>
                                        </Col>
                                        <Col lg="6" md="6" sm="12">
                                            <div style={{ textAlign: 'right', marginTop: '3px' }}>
                                                <a href="#" onClick={() => handleClickSelecionarTodasLojas()} style={{ marginTop: '10px' }}>
                                                    {'Selecionar Todos'}
                                                </a>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Select
                                        name="lojas"
                                        styles={customStyles}
                                        options={options_lojas}
                                        getOptionLabel={o => o.label}
                                        getOptionValue={o => o.value}
                                        value={options_lojas.filter(({ value }) => lojas.filter(f => f.value == value).length > 0)}
                                        onChange={(o) => handleChangeLojas(o)}
                                        classNamePrefix="select"
                                        placeholder="[ Selecione ]"
                                        isMulti={true}
                                        ref={e => register({ name: "lojas" })}
                                    />
                                </FormGroup>
                            </Col>
                            {visibleRateio &&
                                <Col lg="2" md="6" sm="12">
                                    <FormGroup>
                                        <label className="form-control-label">Rateio ADM *</label>
                                        <Select
                                            name="rateioAdm"
                                            options={options_rateioADM}
                                            getOptionLabel={o => o.label}
                                            getOptionValue={o => o.value}
                                            value={options_rateioADM.filter(f => f.value == rateioADM)}
                                            defaultValue="NAO"
                                            onChange={(o) => handleChangeRateioADM(o.value)}
                                            classNamePrefix="select"
                                            placeholder="[ Selecione ]"
                                            ref={e => register({ name: "rateioAdm" })}
                                        />
                                    </FormGroup>
                                </Col>
                            }
                        </Row>
                        <Row>
                            <Col lg="12" md="12" sm="12" className="text-center">
                                <Button color="info" type="button" onClick={handleClickFiltrar}><i className="fas fa-filter"></i> Filtrar</Button>
                            </Col>
                        </Row>
                    </>
                }
                {visibleGraficoEbitda &&
                    <Row>
                        <Col lg="12" md="12" sm="12">
                            <ColoredLine color="red" />
                            <h5 className="text-center" style={{ marginTop: '-50px' }}><strong>EBITDA</strong></h5>
                        </Col>
                        <Col lg="12" md="12" sm="12" style={{ marginTop: '10px' }}>
                            <EbtidaChart ebitdaData={ebitdaData}> </EbtidaChart>
                        </Col>
                    </Row>
                }

                {visibleReceitaOperacionalChart &&
                    <Row>
                        <Col lg="12" md="12" sm="12">
                            <ColoredLine color="red" />
                            <h5 className="text-center" style={{ marginTop: '-50px' }}><strong>RECEITA OPERACIONAL</strong></h5>
                        </Col>
                        <Col lg="12" md="12" sm="12" style={{ marginTop: '10px' }}>
                            <ReceitaOperacionalChart receitaOperacionalData={receitaOperacionalData}></ReceitaOperacionalChart>
                        </Col>
                    </Row>
                }

                {visibleDespesaChart &&
                    <Row>
                        <Col lg="12" md="12" sm="12">
                            <ColoredLine color="red" />
                            <h5 className="text-center" style={{ marginTop: '-50px' }}><strong>DESPESA</strong></h5>
                        </Col><br></br>
                        <Col lg="12" md="12" sm="12">
                            <DespesaChart despesaData={despesaData}></DespesaChart>
                        </Col>
                    </Row>
                }

                {visibleDespesaPessoalChart &&
                    <Row>
                        <Col lg="12" md="12" sm="12">
                            <ColoredLine color="red" />
                            <h5 className="text-center" style={{ marginTop: '-50px' }}><strong>DESPESA PESSOAL</strong></h5>
                        </Col><br></br>
                        <Col lg="12" md="12" sm="12">
                            <DespesaPessoalChart despesaPessoalData={despesaPessoalData}></DespesaPessoalChart>
                        </Col>
                    </Row>
                }

                {visibleDespesaOcupacaoChart &&
                    <Row>
                        <Col lg="12" md="12" sm="12">
                            <ColoredLine color="red" />
                            <h5 className="text-center" style={{ marginTop: '-50px' }}><strong>DESPESA OCUPAÇÃO</strong></h5>
                        </Col><br></br>
                        <Col lg="12" md="12" sm="12">
                            <DespesaOcupacaoChart despesaOcupacaoData={despesaOcupacaoData}></DespesaOcupacaoChart>
                        </Col>
                    </Row>
                }

                {visibleDespesaCartaoChart &&
                    <Row>
                        <Col lg="12" md="12" sm="12">
                            <ColoredLine color="red" />
                            <h5 className="text-center" style={{ marginTop: '-50px' }}><strong>DESPESA COM CARTÃO</strong></h5>
                        </Col><br></br>
                        <Col lg="12" md="12" sm="12">
                            <DespesaCartaoChart despesaCartaoData={despesaCartaoData}></DespesaCartaoChart>
                        </Col>
                    </Row>
                }
                
                {visibleDespesaEstruturalChart &&
                    <Row>
                        <Col lg="12" md="12" sm="12">
                            <ColoredLine color="red" />
                            <h5 className="text-center" style={{ marginTop: '-50px' }}><strong>DESPESA ESTRUTURAL</strong></h5>
                        </Col><br></br>
                        <Col lg="12" md="12" sm="12">
                            <DespesaEstruturalChart despesaEstruturalData={despesaEstruturalData}></DespesaEstruturalChart>
                        </Col>
                    </Row>
                }

                {visibleTableDRE && <Row>
                    <Col lg="12" md="12" sm="12">
                        <ColoredLine color="red" />
                        <h5 className="text-center" style={{ marginTop: '-50px' }}><strong>DRE</strong></h5>
                    </Col><br></br>


                    <Col lg="12" md="12" sm="12" style={{ marginTop: '20px' }}>
                        <TableDadosDRE tableDREData={tableDREData}></TableDadosDRE>
                    </Col>
                </Row>
                }
            </div>
        </>
    );
}